import type React from 'react';

import {
	checkCircleStyles,
	getItemStyles,
	itemContentStyles,
	itemDescriptionStyles,
	itemIconContainerStyles,
	itemTitleStyles,
} from './styled';

interface ChecklistItemProps {
	icon: React.ReactNode;
	title: string;
	description: string;
	isChecked: boolean;
	onToggle: () => void;
	delay: number;
}

const CheckmarkIcon = () => (
	<svg
		width='14'
		height='14'
		viewBox='0 0 14 14'
		fill='none'
	>
		<path
			d='M2.5 7L5.5 10L11.5 4'
			stroke='#ffffff'
			strokeWidth='2.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

const ChecklistItem: React.FC<ChecklistItemProps> = ({ icon, title, description, isChecked, onToggle, delay }) => (
	<div
		role='checkbox'
		aria-checked={isChecked}
		aria-label={title}
		tabIndex={0}
		style={{
			...getItemStyles(isChecked),
			animation: `checklistSlideUp 400ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms both`,
		}}
		onClick={onToggle}
		onKeyDown={(e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				onToggle();
			}
		}}
	>
		<div style={itemIconContainerStyles(isChecked)}>{icon}</div>

		<div style={itemContentStyles}>
			<p style={itemTitleStyles}>{title}</p>
			<p style={itemDescriptionStyles}>{description}</p>
		</div>

		<div style={checkCircleStyles(isChecked)}>{isChecked && <CheckmarkIcon />}</div>
	</div>
);

export default ChecklistItem;
